import { render, staticRenderFns } from "./PartnerWrapper.vue?vue&type=template&id=e82c6752"
import script from "./PartnerWrapper.vue?vue&type=script&lang=js"
export * from "./PartnerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports